export const LOCALENV = "prod";

// environment type ==>
export const DEV = "dev";
export const QA = "qa";
export const UAT = "uat";
export const PROD = "prod";
export const MAINT = "maint";
// <==
